function n(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isObject.js
// module id = 86
// module chunks = 41